import {ResolvedNewJoiner} from "../../api/ResolvedNewJoinerStore";
import {NewJoinerOperations} from "./NewJoinerApi";
import React, {useMemo} from "react";
import {ChecklistItemCategory} from "../../api/Model";
import {ChecklistGroup} from "./NewJoinerChecklistItem";
import {Stack, Typography} from "@mui/material";
import {ColorChip} from "../../components/color-chip/ColorChip";
import {blue, green, grey, pink} from "@mui/material/colors";

const shirtStyleColors: Record<string, string> = {
    'unisex': green[300],
    'female': pink[300],
    'male': blue[100],
};

export function WelcomePackChecklistGroup({newJoiner, operations}: {
    newJoiner: ResolvedNewJoiner,
    operations: NewJoinerOperations,
}) {
    const toggles = useMemo(
        () => operations.checklistToggles[ChecklistItemCategory.WelcomePack],
        [operations.checklistToggles],
    );

    const shirtStyle = newJoiner.employee?.shirtStyle;
    const wearSize = newJoiner.employee?.wearSize;
    return toggles.length > 0 ? (
        <ChecklistGroup
            nestedToggles={toggles}
            disabled={!newJoiner.employee}
        >
            <Stack direction="row" alignItems="center" gap={1}>
                <Typography variant="body1">Welcome Pack</Typography>
                {shirtStyle && (
                    <ColorChip label={shirtStyle} size="small" variant="outlined" color={shirtStyleColors[shirtStyle]}/>
                )}
                {wearSize && (
                    <ColorChip label={wearSize} size="small" variant="outlined" color={grey[800]}/>
                )}
            </Stack>
        </ChecklistGroup>
    ) : null;
}